//import { styled } from '@mui/material/styles';
//import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';


//export  const CTooltip = styled(({ className, ...props }) => (
//    <Tooltip {...props} classes={{ popper: className }} />
//  ))(({ theme }) => ({
//    [`& .${tooltipClasses.tooltip}`]: {
//          backgroundColor: 'rgba(0, 0, 0, 0.87)',
//          color: 'rgba(255, 255, 255, 1)',
//      boxShadow: theme.shadows[1],
//      fontSize: 14,
//    },
//  }));


import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const CTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(0, 0, 0, 0.87)',
        color: 'rgba(255, 255, 255, 1)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: 'rgba(0, 0, 0, 0.87)', // Fait correspondre la flèche au fond du tooltip
    },
}));